import {useState} from 'react';

import ContainerCard from '../../../../components/ui/ContainerCard';
import Table from '../../../../components/ui/Table';
import {exportExpenseDataToCsv} from '../../functions/exportDataToCsv';

const ExpensesTable = ({data, tableConfig, handleButtonClick, loading, datePickerValue, missionStatus, cannotBeModified}) => {
    const [csvExportLoading, setCsvExportLoading] = useState(false);
    const [csvProps, setCsvProps] = useState({
        filename: 'empty.csv',
        headers: [],
        data: []
    });

    const handleExportExpenseDataToCsv = () => exportExpenseDataToCsv(
        data,
        setCsvProps,
        setCsvExportLoading,
        datePickerValue
    );

    return (
        <ContainerCard
            title='Frais'
            buttonContent='Nouveau frais'
            onButtonClick={handleButtonClick}
            downloadButtonDisplayed={(data.length > 0 && !loading)}
            onDownloadButtonClick={handleExportExpenseDataToCsv}
            coloredButtonDisplayed={missionStatus < 2 && !cannotBeModified}
            csvProps={csvProps}
            csvExportLoading={csvExportLoading}
            overflow='overflow-inherit'
        >
            <Table
                data={data}
                tableConfig={tableConfig}
                height='h-[400px]'
                loading={loading}
            />
        </ContainerCard>
    )
}

export default ExpensesTable
